export default __webpack_public_path__ + "static/media/PastTraditions.1acafd52.mp3";